import type { TranslationResource } from './en';

export const fr: TranslationResource = {
  title: 'AutoCut - Programme d’installation',
  downloading: 'Téléchargement d’AutoCut',
  downloadedTitle: 'AutoCut a été téléchargé avec succès !',
  closingCountdown: 'Fermeture dans {{count}} secondes',
  alreadyInstalledTitle: 'AutoCut est déjà installé',
  alreadyInstalledHelp:
    'AutoCut fonctionne désormais en application de bureau. Vous pouvez désinstaller cette extension depuis l’application Creative Cloud.',
};
